var object = function (value) {
    return value !== null && typeof value === "object" && !Array.isArray(value);
};
/** Display metadata only; the proof panel separately verifies the canonical signed bytes. */
export var ballotLogDetails = function (message) {
    var _a;
    var body = (_a = message === null || message === void 0 ? void 0 : message.statement) === null || _a === void 0 ? void 0 : _a.body;
    if (!object(body) || (!object(body.BallotReceived) && !object(body.PrivacyCastVote)))
        return null;
    if (!(message === null || message === void 0 ? void 0 : message.ballot_id) || !message.election_id || !message.username)
        return null;
    return {
        ballotId: message.ballot_id,
        electionId: message.election_id,
        pseudonym: message.username,
    };
};
export var pseudonymResolution = function (message) {
    var _a;
    var body = (_a = message === null || message === void 0 ? void 0 : message.statement) === null || _a === void 0 ? void 0 : _a.body;
    if (!object(body) || !object(body.PseudonymResolved))
        return null;
    var _b = body.PseudonymResolved, pseudonym = _b.pseudonym, reason = _b.reason;
    return typeof pseudonym === "string" && typeof reason === "string" ? { pseudonym: pseudonym, reason: reason } : null;
};
